<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "MobileMenuDropdownBlock",
    components: {Link, IconChevronDown},
    props: {
        btnText: {
            required: true,
        },
        route_name: {
            default: null,
        },
        route_params: {
            default: {}
        },
        icon_path: {
            default: null,
        },
        items: {},
        forceOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: this.forceOpen,
        }
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
        },
        buildMenuLink(item) {
            let url = route(item.route_name, {category_title: item.route_params.category_title});

            if (item.route_params.query) {
                const queryParams = new URLSearchParams();

                for (const [key, values] of Object.entries(item.route_params.query)) {
                    queryParams.append(key, JSON.stringify(values));
                }

                url += '?' + queryParams.toString();
            }

            return url;
        }
    }
}
</script>

<template>
    <div>
        <div class="grid grid-cols-12 p-2 ps-0 w-full text-base text-gray-900 rounded-lg transition duration-75 group">
            <template v-if="route_name">
                <Link class="col-span-8 flex items-center gap-3 text-left font-medium"
                      :href="route(route_name, route_params ?? {})">
                    <div v-if="icon_path" class="min-h-[40px] min-w-[40px] w-[40px] h-[40px]">
                        <img alt="" aria-hidden="true" role="presentation"
                             :src="icon_path"
                             class="h-full w-full object-cover"/>
                    </div>
                    {{ btnText }}
                </Link>
            </template>
            <template v-else>
                <div class="col-span-8 flex items-center gap-3 text-left font-medium" @click.prevent="toggleOpen">
                    <div v-if="icon_path" class="min-h-[40px] min-w-[40px] w-[40px] h-[40px]">
                        <img alt="" aria-hidden="true" role="presentation"
                             :src="icon_path"
                             class="h-full w-full object-cover"/>
                    </div>
                    {{ btnText }}
                </div>
            </template>
            <div class="flex items-center justify-end col-span-4"
                 @click.prevent="toggleOpen">
                <IconChevronDown :rotate="isOpen" class="w-5 h-5 transition-transform menu-chevron"/>
            </div>
        </div>
        <ul v-if="isOpen" class=" space-y-2 divide-y">
            <li v-for="(item, index) in items" class="ms-5 pt-2">
                <div v-if="item.sub_menu">
                    <MobileMenuDropdownBlock :btnText="item.title" :items="item.sub_menu"
                                             :route_name="item.route_name"
                                             :route_params="item.route_params"/>
                </div>
                <div v-else>
                    <Link :href="buildMenuLink(item)"
                          class="flex items-center p-2 ps-0 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group">
                        {{ item.title }}
                    </Link>
                </div>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="scss">

</style>
